<div class="flex">
    <app-advanced-search (formData)="applyFilters($event)" [config]="filterConfig" (onsumbit)="downloadReport()" [showSubmit]="true" [showSubmitLabel]="'Выгрузить отчет'"> </app-advanced-search>
</div>
